/* eslint-disable no-param-reassign */

import type { SimpleAnyObject } from '@clearverify/types';

export const collectPropertyValuesCount = <T extends SimpleAnyObject>(
  dataArray: T[],
  property: keyof T,
  propertyCallback?: (property: T[keyof T]) => T[keyof T],
): Record<string, number> => {
  const result = dataArray.reduce((acc: Record<string, number>, currentItem) => {
    let value = currentItem[property];

    if (propertyCallback) value = propertyCallback(value);

    if (value in acc) {
      // FIXME: incorrect typecheck error
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (acc as any)[value] += 1;
    } else {
      acc[value] = 1;
    }

    return acc;
  }, {});

  return result;
};
